<template>
    <button class="round-btn"
            :class="classes"
            :disabled="disabled || loading"
            @click.stop.prevent="$emit('click')">
        <i v-if="loading"
           class="fa-solid fa-spinner fa-spin" />
        <i v-else
           :class="icon"></i>
    </button>
</template>

<script>
export default {
    name: 'RoundBtn',

    props: {
        color: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        filled: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: null,
        },
    },

    emits: [
        'click',
    ],

    computed: {
        classes() {
            return [
                this.color ? 'round-btn-' + this.color : '',
                this.filled ? 'round-btn--filled' : '',
                this.size ? 'round-btn--' + this.size : '',
            ].filter((c) => !!c);
        },
    },
};
</script>
